document.addEventListener('DOMContentLoaded', function () {
  const links = mobileNavbarList;
  const header = document.querySelector('.site-header');
  const navbar = document.querySelector('.mobile-navbar');
  const listContainer = document.querySelector('.mobile-navbar__list');
  let listItems = null;

  if(links) {
    links.forEach(function (link) {
      const linkBlock = document.getElementById(link.id);

      if(linkBlock) {
        const linkElement = document.createElement('button');
        linkElement.classList.add('mobile-navbar__item');
        linkElement.innerText = link.name;
        linkElement.addEventListener('click', function (event) {
          const targetScroll = window.scrollY + (linkBlock.getBoundingClientRect().top - header.getBoundingClientRect().height - 25);
          window.scrollTo({
            left: 0,
            top: targetScroll,
            behavior: 'smooth'
          });
          // listContainer.querySelectorAll('.mobile-navbar__item').forEach((i)=>i.classList.remove('_active'));
          // linkElement.classList.add('_active');
        });
        listContainer.append(linkElement);
        listItems = listContainer.querySelectorAll('.mobile-navbar__item');
      }
    });

    navbar.classList.add('_initialized');

    window.addEventListener('scroll', function (event) {
      let lastActive = null;

      links.forEach(function (link, index) {
        const linkBlock = document.getElementById(link.id);
        if(linkBlock && linkBlock.getBoundingClientRect().top < (window.screenY + (window.innerHeight / 2)) ) {
          lastActive = index
        }
      });

      listItems.forEach((i)=> {
        i.classList.remove('_active')
      });

      if(lastActive != null) {
        listItems[lastActive].classList.add('_active');
        listContainer.scrollLeft = listContainer.scrollLeft + listItems[lastActive].getBoundingClientRect().left -20;
      }
    });
  }
});